import { useQuery } from '@tanstack/react-query';
import { useGraphneAPI } from '@nexelem/graphne-api';

const graphTaskQueryKey = (taskId: string | number) => ['graph-task', taskId.toString()];

export const useGraphneGraphTask = (taskId: string | number) => {
  const graphneAPI = useGraphneAPI();

  return useQuery({
    queryKey: graphTaskQueryKey(taskId),
    queryFn: () => graphneAPI.getGraphneGraphTaskid({ taskId: taskId.toString() }),
    enabled: !!taskId,
  });
};
